import {Component, Inject, OnInit, Renderer2, ViewChild, signal} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule, Location } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MasterdataService } from 'src/app/home/services/masterdata.service';


@Component({
  selector: 'app-add-master-product',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './add-master-product.component.html',
  styleUrls: ['./add-master-product.component.scss', '../../../../app.component.scss', '../../../../shared/base-modal.style.scss']

})
export class AddMasterProductComponent {

  public propData: any;
  public bodyParts: any;
  public selectedImplants: any = {id: "", value: ""};
  public isEdited: boolean = false;
  public nameImplantTxt: string;
  public rkNumberTxt: string;
  public titleTxt: string;
  public rangeTxt: string;
  public descTxt: string;
  public implants: any;
  public search: any;


  constructor(
    public dialogRef: MatDialogRef<AddMasterProductComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private masterdataService: MasterdataService,
    private renderer: Renderer2
  ) {
    if(data){
      this.propData = data;
      this.implants = this.propData.implants;
    }
  }

  ngOnInit(): void {
  if (this.propData && this.propData.type === "edit") {
    console.log(this.propData, " propData");
 
    if (this.propData.implants) {
      console.log(this.propData.implants, "implants");

      let implants = this.propData.implants;
      let implantsIdToFind = this.propData.item.implant_id;
      let foundImplants = null;
      for (let i = 0; i < implants.length; i++) {
        if (implants[i].id === implantsIdToFind) {
          foundImplants = implants[i];
          break;
        }
      }

      if (foundImplants) {
        this.selectedImplants = foundImplants;
        console.log(this.selectedImplants, "selected body ");
        this.onImplantTypeChange(this.selectedImplants);
      } else {
        console.log("No matching body part found for id:", implantsIdToFind);
      }
    } else {
      console.log("No bodyparts data available");
    }

    this.nameImplantTxt = this.propData.item.name;
    this.rkNumberTxt = this.propData.item.rkNumber;
    this.titleTxt = this.propData.item.titleTxt;
    this.rangeTxt = this.propData.item.rangeTxt;
    this.descTxt = this.propData.item.descTxt;
    this.isEdited = true;
  }
  this.renderer.listen('window', 'click', (e: Event) => {
    if (!document.querySelector('.cabinet-dropdown.stores')?.contains(e.target as Node)) {
      this.isImplantDropDown.set(false);
    }
  });
}



  
  
  

  onClose(): void {
    this.dialogRef.close();
  }

  isImplantDropDown = signal(false);

  responseData: any = {};
  public fileType = "";
  public isFile = false;
  public uploadedFile: any;
  public statusType: string = "";
  public statusMessage: string = "";

  changedStoreType: any = {type: "", value: ""};
  public isDragOver = signal(false);


  dropFile(e) {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      this.fileValidation(file)
    }

    this.isDragOver.set(false);
  }

  dragOverFile(e) {
    e.preventDefault();
    this.isDragOver.set(true);
  }

  dragLeaveFile(e) {
    e.preventDefault();
    this.isDragOver.set(false);
  }

  browseFile(e){
    e.preventDefault();
    let fileInput = document.getElementById("file-input");
    fileInput.click();
  }

  dragEndFile(e) {
    e.preventDefault();
    this.isDragOver.set(false);
  }

  onFileChange(event){
    event.preventDefault();
    const file = event.target.files[0];
    if (file) {
      this.fileValidation(file);
    }
  }

  fileValidation(file){
    const validFileTypes = ['csv', 'xlsx', 'xls'];
    let ext = file.name.substring(file.name.lastIndexOf('.') + 1);
    if (validFileTypes.includes(ext)) {
      this.isFile = true;
      this.uploadedFile = file;
    }else{
      this.statusType = 'error';
      this.statusMessage = `File format is invalid. Only Excel and CSV formats are allowed.`;
      this.showWarningToast();
    }
  }

  resetFile(){
    this.isFile = false;
  }

  showWarningToast(){
    const toastContainer = document.getElementById('warning-toast');

    setTimeout(function() {
      toastContainer.classList.add('show');
    }, 100);

    setTimeout(function() {
      toastContainer.classList.remove('show');
    }, 5000);
  }

  onImplantTypeChange(value:any){
      this.selectedImplants = value;
      this.isImplantDropDown.set(false);
  }

  onAdd() {
    let data = { 
      implant_id: this.selectedImplants.id,
      name: this.nameImplantTxt,
      // rkNumberTxt: this.rkNumberTxt,
      title: this.titleTxt,
      // rangeTxt: this.rangeTxt,
      // descTxt: this.descTxt 
    };
   
    if (!data.implant_id) {
      console.error("Invalid selected implant ID");
      return;
    } 
  
    if (this.isEdited) {
      this.masterdataService.masterEditBody('product_categories', this.propData.item.id, data).subscribe((res: any) => {
        this.onClose();

      });
    } else {
      this.masterdataService.masterAddItem('product_categories',data).subscribe((res: any) => {
        this.onClose();
      });
    }
  }
  

}
